import { z } from "zod";

export enum ESectionRoomType {
  BATHROOM = "roomType.bathroom",
  BEDROOM = "roomType.bedroom",
  CORRIDOR = "roomType.hallway",
  HALL = "roomType.entrance",
  KITCHEN = "roomType.kitchen",
  LIVING_ROOM = "roomType.lounge",
  OFFICE = "roomType.office",
  OTHER = "roomType.other",
}

// Global appliance type
export enum EApplianceType {
  WATER_HEATER = "appliances.waterHeater",
  HEATER = "appliances.heater",
  HEATING_FLOOR = "appliances.underfloorHeating",
}

const sectionApplianceDetails = z.object({
  modulatorId: z.number(),
  applianceElectricalType: z.string().nullable(), // returns any appliance type, but we want to handle only 3 types for now
  roomType: z.nativeEnum(ESectionRoomType).nullable(),
});

export type TSectionAppliance = z.infer<typeof sectionApplianceDetails>;

export const sectionAppliancesResponseSchema = z.array(sectionApplianceDetails);

export const patchSectionSchema = z.object({
  name: z.string().nullish(),
  area: z.number().nullish(),
});

export type TPatchSectionBody = z.infer<typeof patchSectionSchema>;
